import { checkDropAuth, client } from './droplrAuth';

export const getDroplrTeamUsers = async () => {
  await checkDropAuth();
  return await client.users.list();
};
